import type { TranslationMessages } from '../../types';

export const attendance: TranslationMessages = {
  title: 'Check-in / Check-out',
  subtitle: 'Theo dõi giờ làm việc và điểm danh của bạn',
  checkin: 'Check In',
  checkout: 'Check Out',
  checking_in: 'Đang Check In...',
  checking_out: 'Đang Check Out...',
  current_status: 'Trạng thái hiện tại',
  checked_in: 'Đã Check In',
  checked_out: 'Đã Check Out',
  status_working: 'Đang làm việc',
  status_off_duty: 'Nghỉ làm',
  status_on_break: 'Đang nghỉ giải lao',
  status_since: 'Từ',
  unknown: 'Không xác định',
  checkin_time: 'Thời gian Check In',
  checkout_time: 'Thời gian Check Out',
  work_duration: 'Thời lượng làm việc',
  break_time: 'Thời gian nghỉ giải lao',
  start_break: 'Bắt đầu nghỉ giải lao',
  end_break: 'Kết thúc nghỉ giải lao',
  break_duration: 'Thời lượng nghỉ giải lao',
  today_hours: 'Giờ làm việc hôm nay',
  total_hours: 'Tổng số giờ',
  break_hours: 'Thời gian nghỉ giải lao',
  overtime_hours: 'Giờ làm thêm',
  weekly_hours: 'Giờ làm việc hàng tuần',
  monthly_hours: 'Giờ làm việc hàng tháng',
  location_detected: 'Đã phát hiện vị trí',
  location_not_available: 'Vị trí không có sẵn',
  notes_optional_label: 'Ghi chú (Tùy chọn)',
  notes_placeholder:
    'Thêm bất kỳ ghi chú nào về việc check-in/check-out của bạn...',
  refresh_status: 'Làm mới',
  refresh_success: 'Trạng thái đã được làm mới thành công',
  refresh_error: 'Không thể làm mới trạng thái',
  login_required_message: 'Vui lòng đăng nhập để truy cập check-in/check-out',
  break_quick_action_title: 'Thời gian nghỉ giải lao',
  break_quick_action_start: 'Bắt đầu nghỉ giải lao',
  break_quick_action_end: 'Kết thúc nghỉ giải lao',
  break_quick_action_label: 'Thời gian nghỉ giải lao',
  break_dialog_title: 'Thời gian nghỉ giải lao',
  break_dialog_need_checkin: 'Bạn cần check in trước khi nghỉ giải lao.',
  break_dialog_end_question:
    'Bạn hiện đang nghỉ giải lao. Bạn có muốn kết thúc nghỉ giải lao không?',
  break_dialog_start_question: 'Bạn có muốn bắt đầu nghỉ giải lao không?',
  break_dialog_checkin_first: 'Check In trước',
  view_timesheet: 'Xem bảng chấm công',
  view_timesheet_opening: 'Đang mở bảng chấm công...',
  view_timesheet_navigate_message:
    'Vui lòng điều hướng đến tab Điểm danh để xem bảng chấm công của bạn',
};
